import { BTX_BNT } from '@vfde-sails/constants';
import {
    getLoginData,
    getSiteStructure,
    PageViewTrackingData,
    TrackingBtx,
    TrackingFlowType,
    TrackingInformationTrigger,
    TrackingInformationUiType,
    TrackingLoginStatus,
    TrackingPageType,
    TrackingTargetAudience,
    TRACKING_INFORMATION_ACTION_REVEAL,
    TRACKING_PLATFORM_TYPE_RESPONSIVE,
    TRACKING_SITE_AREA_MOBILITY,
    trackIt,
    TrackType,
} from '@vfde-sails/tracking';
import {
    TABS_LABEL_CLASSNAME,
    TABS_TAB_CLASSNAME,
} from '@vfde-brix/ws10/tabs';

const createTrackingPageView = (): void => {
    // get meta element from head to use page name
    const pageName = document.getElementsByName('additionalPageName')[0].getAttribute('content')!;
    const trackPageViewData: PageViewTrackingData = {
        /* eslint-disable camelcase, @typescript-eslint/naming-convention, jsdoc/require-jsdoc */
        page_levels: getSiteStructure(pageName, BTX_BNT),
        page_type: TrackingPageType.ProductListing,
        login_status: getLoginData() ? TrackingLoginStatus.LoggedIn : TrackingLoginStatus.NotLoggedIn,
        site_area: TRACKING_SITE_AREA_MOBILITY,
        platform_type: TRACKING_PLATFORM_TYPE_RESPONSIVE,
        flow_type: TrackingFlowType.IotDevice,
        business_transaction_type: TrackingBtx.Bnt,
        line_of_customer: TrackingTargetAudience.Consumer,
        /* eslint-enable */
    };

    trackIt('pageview', trackPageViewData);
};

function trackTabClick (this: HTMLElement) {
    const tabText = this.getElementsByClassName(TABS_LABEL_CLASSNAME)[0].getAttribute('data-text');

    const trackingData = {
        /* eslint-disable camelcase, @typescript-eslint/naming-convention */
        information_action: TRACKING_INFORMATION_ACTION_REVEAL,
        information_ui_type: TrackingInformationUiType.Panel,
        information_trigger: TrackingInformationTrigger.Tab,
        information_name: `onenumber ${tabText} information`,
        /* eslint-enable camelcase, @typescript-eslint/naming-convention */
    };

    trackIt(TrackType.Information, trackingData);
}

const initTabTracking = (tabsContainer: HTMLElement) => {
    const tabElements = tabsContainer.getElementsByClassName(TABS_TAB_CLASSNAME);

    for (const tab of tabElements) {
        tab.addEventListener('click', trackTabClick);
    }
};

createTrackingPageView();
const tabsContainer = document.getElementById('stone-devices-tabs');
tabsContainer && initTabTracking(tabsContainer);
